import { Modal } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { debounce } from "lodash";

// component
import { ReactSelect } from "../kits/Inputs/Inputs";
import CustomButton from "../kits/button/CustomButton";
import useAxios from "../../services/useAxios";
import DatePiker from "../datepiker/datePiker";
export default function LeavingStoreRoom({
  openModal,
  setOpenModal,
  receiverUser,
  setReceiverUser,
  senderUser,
  setSenderUser,
  userApi,
  userListApi,
  userDebounce,
  userItem,
  ExitInventory,
  selectedRecord,
}) {
  // const { execute: getUserApi } = useAxios("test/fullusers ");
  // const [receiverUser, setReceiverUser] = useState([
  //   { value: "none", label: "هیچ کدام " },
  // ]);
  const [text, setText] = useState([]);
  const [inputData, setInputData] = useState({
    sender: "",
    receiver: "",
    date: "",
  });
  // func
  const changeHandler = (value, name, index) => {
    setInputData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  // console.log(receiverUser, "reciver");
  // console.log(userItem.dataUser, "userItem");
  console.log(inputData, "userItem");

  return (
    <>
      <Modal
        show={openModal}
        onHide={() => {
          setOpenModal(false);
          setInputData({ sender: "", receiver: "", date: "" });
        }}
      >
        <Modal.Header closeButton>خروج از انبار </Modal.Header>
        <Modal.Body>
          <div className="mt-2">
            <ReactSelect
              title="کاربر تحویل دهنده "
              itemsList={userItem.dataUser}
              inputValue={inputData.sender}
              onChangeFunc={(e) => {
                changeHandler(e, "sender");
              }}
              onInputChangeFunc={(event) => {
                userDebounce(event);

                console.log("event", event);
              }}
            ></ReactSelect>
          </div>
          <div className="mt-4">
            <ReactSelect
              title="کاربر تحویل گیرنده "
              itemsList={userItem.dataUser}
              inputValue={inputData.receiver}
              onChangeFunc={(e) => {
                changeHandler(e, "receiver");
              }}
              onInputChangeFunc={(event) => {
                userDebounce(event);
              }}
            ></ReactSelect>
          </div>
          <div className="mt-4">
            <div
              className="title-date"
              style={{
                color: " #677788",
                fontSize: " 0.75rem",
                marginBottom: "0.5rem",
              }}
            >
              زمان خروج
            </div>
            <DatePiker
              value={parseInt(inputData.date) * 1000}
              setValue={(e) => {
                changeHandler(e.unix, "date");
              }}
            ></DatePiker>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex">
            <CustomButton
              type="outline"
              color="danger"
              className="mx-3"
              onClick={() => {
                setOpenModal(false);
                setInputData({ sender: "", receiver: "", date: "" });
              }}
            >
              انصراف
            </CustomButton>
            <CustomButton
              type="outline"
              color="success"
              onClick={() =>
                ExitInventory(
                  inputData?.date ?? "",
                  selectedRecord?.id ?? "",
                  inputData?.sender?.id ?? "",
                  inputData?.receiver?.id ?? ""
                )
              }
            >
              ثبت
            </CustomButton>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
